import { Navigate, useRoutes } from "react-router-dom";
// config
import { mainRoutes } from "./main";

import { dashboardRoutes } from "./dashboard";
import DashboardView from "../../sections/dashboard/view";
import LoginPage from "../../pages/auth/jwt/login";
import AuthClassicLayout from "../../layouts/auth/classic";
import { authRoutes } from "./auth";
import ProtectedRoute from "../../auth/protected-route";

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Navigate to="/login" replace />,
    },
    ...authRoutes,
    // {
    //   element: <ProtectedRoute />,
    //   children: [...dashboardRoutes],
    // },
    {
      path: "/",
      element: <ProtectedRoute />,
      children: dashboardRoutes,
    },
    // {
    //   path: 'login',
    //   element: <AuthClassicLayout> <LoginPage/> </AuthClassicLayout>,
    // },
    // {
    //   path: 'dashboard',
    //   element: <DashboardView />,
    // },

    // // Dashboard routes
    // ...dashboardRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
